var S = Object.defineProperty;
var U = (c, i, t) => i in c ? S(c, i, { enumerable: !0, configurable: !0, writable: !0, value: t }) : c[i] = t;
var A = (c, i, t) => U(c, typeof i != "symbol" ? i + "" : i, t);
import { FieldDirectiveEnum as L } from "../field/types/index.js";
import { equalsWhenLowerCased as h, idFromObjectName as B } from "../../shared/utils.js";
import { F as p } from "../../index-gVtEopq1.js";
const q = (c, i) => {
  var e, o, N, r;
  const t = (e = c.types) == null ? void 0 : e.find(
    (n) => h(n.name, i.parents.first ?? "")
  ), s = (o = c.types) == null ? void 0 : o.find(
    (n) => h(n.name, i.parents.second ?? "")
  ), a = ((N = t == null ? void 0 : t.fields.find(
    (n) => n.directives.includes(L.CONNECTOR)
  )) == null ? void 0 : N.name) ?? "id", m = ((r = s == null ? void 0 : s.fields.find(
    (n) => n.directives.includes(L.CONNECTOR)
  )) == null ? void 0 : r.name) ?? "id";
  return {
    first: {
      parentTypeName: t == null ? void 0 : t.name,
      parentTypeId: t == null ? void 0 : t.id,
      connector: a,
      fieldName: t && a && B(t.name, a)
    },
    second: {
      parentTypeName: s == null ? void 0 : s.name,
      parentTypeId: s == null ? void 0 : s.id,
      connector: m,
      fieldName: s && m && B(s.name, m)
    }
  };
};
class H {
  constructor(i, t = !1) {
    A(this, "excludeList");
    this.apiDeclaration = i, this.isUpdate = t, this.apiDeclaration = i, this.excludeList = [...t ? ["id"] : [], "createdAt", "updatedAt"];
  }
  getMutationInput(i, t = []) {
    var w, x, E, v, D, F, T, b, y, z, R, j;
    const s = (w = i.ofType) == null ? void 0 : w.toLowerCase(), a = i.id;
    if (!s || this.isUpdate && !a)
      return;
    const m = (x = this.apiDeclaration.types) == null ? void 0 : x.find(
      (d) => h(d.id, s)
    );
    if (!m)
      return;
    const e = q(
      this.apiDeclaration,
      m
    ), o = m.fields.find(
      (d) => d == null ? void 0 : d.directives.includes(L.SORTBY)
    ), N = Object.entries(i.fields).reduce(
      (d, [l, f]) => {
        const u = m.fields.find(
          (M) => h(M.name, l)
        ), I = u == null ? void 0 : u.type;
        return this.excludeList.includes(l) || u != null && u.directives.includes("@dynamic_field") && !t.includes(l) || (I !== p.String && f === "" ? d[l] = null : I === p.Integer && typeof f == "string" ? d[l] = parseInt(f) : I === p.Float && typeof f == "string" ? d[l] = parseFloat(f) : d[l] = f), d;
      },
      {}
    ), r = {
      first: ((E = e == null ? void 0 : e.first) == null ? void 0 : E.fieldName) && i.fields[(v = e == null ? void 0 : e.first) == null ? void 0 : v.fieldName] && {
        link: (F = (D = e == null ? void 0 : e.first) == null ? void 0 : D.parentTypeId) == null ? void 0 : F.toLowerCase(),
        with: (T = e == null ? void 0 : e.first) == null ? void 0 : T.fieldName
      },
      second: ((b = e == null ? void 0 : e.second) == null ? void 0 : b.fieldName) && i.fields[(y = e == null ? void 0 : e.second) == null ? void 0 : y.fieldName] && {
        link: (R = (z = e == null ? void 0 : e.second) == null ? void 0 : z.parentTypeId) == null ? void 0 : R.toLowerCase(),
        with: (j = e == null ? void 0 : e.second) == null ? void 0 : j.fieldName
      }
    }, n = r.first || r.second ? {
      connections: {
        ...r.first ? { first: r.first } : {},
        ...r.second ? { second: r.second } : {}
      }
    } : {}, O = o != null && o.name ? { directives: { sortby: o == null ? void 0 : o.name } } : {};
    return this.isUpdate ? {
      ...i,
      ofType: s,
      fields: N,
      id: a,
      ...O,
      ...n
    } : {
      ...i,
      ofType: s,
      fields: N,
      ...O,
      ...n
    };
  }
}
export {
  H as GenericTypeMutationInputBuilder
};
